import { Box, Grid } from "@mui/material";
import MenuTab from "../../../component/tabs/MenuTab";
import CantineForm from "./CantineForm";
import { useSelector } from "react-redux";
// import StabilimentoForm from "./StabilimentoForm/StabilimentoForm"
// import SubImposteForm from "../Imposte/SubImposteForm"

const SubCantine = ({ Component }) => {
  const singleData = useSelector((state) => state.cantine.singleCantines);

  return (
    <>
      <div className="pageTemplate">

        <Grid container spacing={3}>
          <Grid size={{ xs: 12, md: 4, lg: 3 }}>
            <CantineForm singleData={singleData} />
          </Grid>
          <Grid size={{ xs: 12, md: 8, lg: 9 }}>
            <Box className="TemplateForm__right">
              <MenuTab subCantine={true} />
            </Box>
            {Component && <Component />}
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default SubCantine;
